// var AppDispatcher = require('../dispatcher/AppDispatcher');

var currentAppActions = null;
var configOverride = null;

var ExternalActions = {
  initialize : function(appActions)
  {
    currentAppActions = appActions;

    window.addEventListener("message", this.receiveMessage, false);
  },

  receiveMessage : function(event)
  {
    try {
      var data = JSON.parse(event.data);
      switch (data.method) {
        case "loadFeatureDictionary":
          currentAppActions._appManager.setFeatureDatas(data.params);
          currentAppActions._navigator.forceUpdate();
          break;
        case "loadColorDictionary":
          currentAppActions._appManager.setColorDictionary(data.params);
          currentAppActions._navigator.forceUpdate();
          break;
        case "reload":
          if( typeof data.params !== 'undefined' && currentAppActions != null ) currentAppActions._appManager.configOverride = data.params;
          currentAppActions._navigator.props.restartApp();
          break;
        default:

      }
    } catch (e) {
      // console.log("parse error", e, event)
    } finally {

    }
  },


};

module.exports = ExternalActions;
